import React, { Component, Fragment, Suspense } from 'react';
import {
  Router,
  Route,
  // Redirect,
  Switch,
  withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import GBIHeader from '../header/components/Header';
import './gbi-app.scss';
import history from './gbiHistory';
// import GBIHome from './GBIHome';
import * as logger from '../util/logger';
import { fetchScores } from '../admin/scoreDefinitions/actions';
import { fetchCows } from '../cows/actions';
import PropTypes from 'prop-types';
import ProtectedRoute from '../main/components/ProtectedRoute';
import GBIFooter from './GBIFooter';
import smoothscroll from 'smoothscroll-polyfill';
import { getCows } from '../cows/reducer';
import LoadingPage from '../util/components/LoadingPage';
import { Helmet } from 'react-helmet';
import NotFound from '../util/components/NotFound';
import { isAuthenticated } from '../util/jwt';
import DashboardHome from './DashboardHome';
import ServerListView from '../user/components/ServerListView';
// import { isLoggedIn } from '../user/reducer';

// const RateMyAnimal = React.lazy(
//   () => import(/* webpackChunkName: "RateMyAnimal" */
//     '../GBIDemo/components/RateMyAnimal')
// );
// const AnimalSpec = React.lazy(
//   () => import(/* webpackChunkName: "AnimalSpec" */
//     '../GBIAnimal/components/AnimalSpec')
// );
const ScoreCard = React.lazy(
  () => import(/* webpackChunkName: "ScoreCard" */
    '../GBIAnimal/components/ScoreCard')
);
// const Contact = React.lazy(
//   () => import(/* webpackChunkName: "Contact" */
//     './Contact')
// );
// const PricingGuidelines = React.lazy(
//   () => import(/* webpackChunkName: "PricingGuidelines" */
//     './footer/PricingGuidelines')
// );
// const Intro = React.lazy(
//   () => import(/* webpackChunkName: "Intro" */
//     '../GBIDemo/components/Intro')
// );
const GBILogin = React.lazy(
  () => import(/* webpackChunkName: "GBILogin" */
    '../user/components/GBILogin')
);
const Notifications = React.lazy(
  () => import(/* webpackChunkName: "Notifications" */
    '../notifications/components/Notifications')
);
const GBIAnimal = React.lazy( // Just used for testing
  () => import(/* webpackChunkName: "GBIAnimal" */
    '../GBIAnimal/components/GBIAnimal')
);
// const About = React.lazy(
//   () => import(/* webpackChunkName: "about" */
//     '../pages/about/components/Provider')
// );
// const GoodBeef = React.lazy(
//   () => import(/* webpackChunkName: "GoodBeef" */
//     '../pages/goodbeef/components/Provider')
// );
// const Recipes = React.lazy(
//   () => import(/* webpackChunkName: "Recipes" */
//     '../pages/recipes/components/Provider')
// );
const GBIAccountPage = React.lazy(
  () => import(/* webpackChunkName: "GBIAccountPage" */
    '../user/components/GBIAccountPage')
);
// const FeedbackForm = React.lazy(
//   () => import(/* webpackChunkName: "FeeebackForm" */
//     '../user/components/FeeebackForm')
// );
const ConfirmRegistration = React.lazy(
  () => import(/* webpackChunkName: "ConfirmRegistration" */
    '../admin/components/ConfirmRegistration')
);
const SetPassword = React.lazy(
  () => import(/* webpackChunkName: "SetPassword" */
    '../admin/components/SetPassword')
);
const ForgottenPassword = React.lazy(
  () => import(/* webpackChunkName: "ForgottenPassword" */
    '../admin/components/ForgottenPassword')
);
const FarmerSection = React.lazy(
  () => import(/* webpackChunkName: "FarmerSection" */
    '../admin/dashboards/components/FarmerSection')
);
const ConsumerDashboard = React.lazy(
  () => import(/* webpackChunkName: "ConsumerDashboard" */
    '../admin/dashboards/components/ConsumerDashboard')
);
const WhereToBuyMap = React.lazy(
  () => import(/* webpackChunkName: "WhereToBuyMap" */
    '../wheretobuy/compontents/WhereToBuyMap')
);
const Cows = React.lazy(
  () => import(/* webpackChunkName: "Cows" */
    '../cows/list/components/Cows')
);
const CowDetails = React.lazy(
  () => import(/* webpackChunkName: "CowDetails" */
    '../cows/components/CowDetails')
);
const Pitch = React.lazy(
  () => import(/* webpackChunkName: "Pitch" */
    './Pitch')
);

logger.init();

const mapStateToProps = state => ({
  cows: getCows(state)
});

const mapDispatchToProps = dispatch => ({
  fetchCows: () => dispatch(fetchCows()),
  fetchScoreDefs: () => dispatch(fetchScores())
});

class App extends Component {
  componentDidMount () {
    document.title =
      'The GoodBeef Index | a fair price for explicitly authenticated quality';
    this.props.fetchScoreDefs();
    if (this.props.cows.length < 1 && isAuthenticated()) {
      this.props.fetchCows();
    }
    smoothscroll.polyfill();
  }
  render () {
    const meta = `
      Produced responsibly, beef is good for us and good for the planet.
      Find out more at the GoodBeef Index
    `;
    const HeaderWithRouter = withRouter(props => <GBIHeader { ...props} />);
    return (
      <Router history={history} >
        <Helmet>
          <title>
            The GoodBeef Index | Grading, Authentication and Tracibility
          </title>
          <meta name="description" content={ meta } />
        </Helmet>
        <Fragment>
          <HeaderWithRouter />
          <Suspense fallback={<div></div>}>
            <Notifications />
          </Suspense>
          <Suspense fallback={<LoadingPage />}>
            <Switch>
              <Route exact path="/" render={ props => (
                <DashboardHome />
              )} />
              <ProtectedRoute path="/account" render={ props => (
                <GBIAccountPage { ...props } />
              )} />
              <Route path="/public" render={ props => <ServerListView { ...props } /> } />
              {/*  <Route path="/good-beef" render={
                 props => <GoodBeef { ...props } />
               } />
               <Route path="/about" render={
                 props => <About { ...props } />
               } />
               <Route path="/recipes" render={
                 props => <Recipes { ...props } />
               } />
               <Route exact path="/rate-my-animal" render={
                 (props) => <Intro { ...props } />
               } />
               <Route path="/rate-my-animal/:section" render={
                 (props) => <RateMyAnimal { ...props } /> } />
               <Route path="/animal-spec/beefbook-id/:bbID"
                 render={ props => (
                   <Redirect to={ `/animal/${props.match.params.bbID}` } />
                 )}
               />
               <Route path="/animal-spec" render={
                (props) => <AnimalSpec { ...props } /> } />
              <Route exact path="/contact" render={
                (props) => <Contact { ...props } /> } /> */}
              <Route path="/animal/:bbID" render={
                // just used for testing
                props => <GBIAnimal { ...props } /> } />
              <Route exact path="/login" render={
                props => <GBILogin { ...props } /> } />
              <Route path="/confirm-registration/:authCode/:id" render={
                props => <ConfirmRegistration { ...props } /> } />
              <Route path="/set-password/:authCode/:id" render={
                props => <SetPassword { ...props } /> } />
              <Route exact path="/forgotten-password/" render={
                props => <ForgottenPassword { ...props } /> } />
              {/* <Route exact path='/pricing-guidelines' render={
                (props) => <PricingGuidelines { ...props } /> } /> */}
              <Route path='/for-farmers' render={
                props => <FarmerSection { ...props } /> } />
              <Route exact path='/for-consumers' render={
                props => <ConsumerDashboard { ...props } /> } />
              <Route path='/for-consumers/where-to-buy' render={
                props => <WhereToBuyMap { ...props } /> } />
              <Route exact path="/cattle/:type" render={
                (props) => <Cows { ...props} /> } />
              <Route path="/cattle/:type/:cowId/:cowName"
                render={ (props) => <CowDetails { ...props } /> } />
              <Route path="/pitch" component={ Pitch } />
              <Route component={ NotFound } />
            </Switch>
          </Suspense>
          <Route path='/' render={
            props => <GBIFooter { ...props } />
          } />
          <Suspense fallback={<div></div>}>
            {/* <Route path='/' render={
              props => <FeedbackForm { ...props } />
            } /> */}
            <Route exact
              path="/animal-spec/scorecard/:attribute" render={
                props => <ScoreCard { ...props } /> } />
          </Suspense>
        </Fragment>
      </Router>
    );
  }
}

App.propTypes = {
  fetchScoreDefs: PropTypes.func,
  fetchCows: PropTypes.func,
  cows: PropTypes.array
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
